import type { Dispatch, SetStateAction } from 'react';
import type { NavigateFunction } from 'react-router-dom';
import { constants } from 'appConstants';
import { publish } from '@ltvco/refresh-lib';
import { useSession } from '@ltvco/refresh-lib/v1';

export const AccountInformationOptions = [
  {
    name: 'Edit Name',
    display: 'Edit Name',
    value: 'Edit Name',
    constantValue: 'EDIT_NAME',
  },
  {
    name: 'Edit Email',
    display: 'Edit Email',
    value: 'Edit Email',
    constantValue: 'EDIT_EMAIL',
  },
  {
    name: 'Add Phone Number',
    display: 'Edit Phone Number',
    value: 'Add Phone Number',
    constantValue: 'ADD_PHONE_NUMBER',
  },
  {
    name: 'Change Password',
    display: 'Change Password',
    value: 'Change Password',
    constantValue: 'CHANGE_PASSWORD',
  },
  {
    name: 'Edit Payment Info',
    display: 'Edit Payment Info',
    value: 'Edit Payment Info',
    constantValue: 'EDIT_PAYMENT_INFO',
  },
  {
    name: 'Cancel My Account',
    display: 'Cancel My Account',
    value: 'Cancel My Account',
    constantValue: 'CANCEL_MY_ACCOUNT',
  },
];

export const editOptionClicked = (
  editing: string | null,
  openModal: (open: boolean) => void,
  setEditing: Dispatch<SetStateAction<string | null>>
) => {
  if (editing === 'Edit Payment Info') {
    openModal(true);
  } else {
    setEditing(
      AccountInformationOptions.find((option) => option.name === editing)
        ?.constantValue || editing
    );
  }
};

export const GenericCtaCardProps = (navigate: NavigateFunction) => {
  const {
    session: { account },
  } = useSession();
  const has_sso_connections = account?.account?.user_info?.has_sso_connections;

  // Google and Apple Brands per provider: https://github.com/ltvco/beenverified_com/blob/master/config/initializers/omniauth.rb#L1 LC 04/07/25
  const sso_enabled = {
    google: true,
    apple: true,
  };

  const props = [
    {
      headerText: `${
        has_sso_connections ? '' : 'Connect or '
      } Edit Login Options`,
      bodyText: `Add ${has_sso_connections ? 'or remove' : ''} your ${
        sso_enabled.google && sso_enabled.apple
          ? 'Google or Apple'
          : sso_enabled.google
          ? 'Google'
          : sso_enabled.apple
          ? 'Apple'
          : ''
      } Login ${
        has_sso_connections ? '' : 'on top of your account password & email'
      }`,
      buttonText: 'Edit Login Options',
      imgUrl: constants.images.imgSingleSignOnCta,
      onCtaClick: () => window.open(constants.links.setupSsoLink, '_blank'),
      dataCy: 'login_options_cta',
    },
    {
      headerText: 'Search property reports',
      bodyText: 'Search an address to find out home value, ownership and more',
      buttonText: 'Search an address now',
      imgUrl: constants.images.imgAddressGeneric,
      onCtaClick: () => {
        publish('openPropertySearch');
      },
    },
    {
      headerText: 'Search background reports',
      bodyText: 'Find arrest records, contact information and more',
      buttonText: 'Search by name now',
      imgUrl: constants.images.imgSpecializedBackgroundCheck,

      onCtaClick: () => {
        publish('openPersonSearch');
      },
    },
    //TODO: Uncomment when these features are ready
    // {
    //   headerText: 'Monitor 10 different reports',
    //   bodyText: 'Get alerted about new data on reports as we become aware',
    //   buttonText: 'See more',
    //   imgUrl: constants.imgBell,

    //   onCtaClick: () => navigate('/dashboard/alertme'),
    // },
    // {
    //   headerText: 'Monitor your online identity',
    //   bodyText:
    //     'Monitor your online identity to get notified if any changes are detected',
    //   buttonText: 'Start monitoring now',
    //   imgUrl: constants.imgIdHub,
    //   onCtaClick: () => navigate('/dashboard/identity-hub'),
    // },
    {
      headerText: 'Dark Web Scan',
      bodyText:
        'See if the email you signed up with may have been leaked in a data breach',
      buttonText: 'Scan now',
      imgUrl: constants.images.imgDarkWebScan,
      onCtaClick: () => navigate('/dashboard/dark-web'),
      dataCy: 'dark_web_cta',
    },
    {
      headerText: 'Unclaimed Money',
      bodyText: 'Did you know 1 in 10 American have unclaimed Money?',
      buttonText: 'Find out now',
      imgUrl: constants.images.imgSpecializedUnclaimedMoney,
      onCtaClick: () => navigate('/dashboard/unclaimed-money'),
      dataCy: 'unclaimed_cta',
    },
  ];

  return { ctaCardProps: props, length: props.length };
};
